import React, { useEffect, useCallback } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { activateNonAuthLayout } from "../../../store/actions";
import { useOktaAuth } from "@okta/okta-react";

export const Logout = () => {
  const { oktaAuth } = useOktaAuth();

  const logoutOktaAuth = useCallback(async () => {
    await oktaAuth.signOut();
  }, [oktaAuth]);

  useEffect(() => {
    activateNonAuthLayout();
    logoutOktaAuth();
  }, [logoutOktaAuth]);

  return (
    <React.Fragment>
      <h1>&nbsp;</h1>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {};
};

export default withRouter(
  connect(mapStatetoProps, { activateNonAuthLayout })(Logout)
);
